const ERROR_CODE = {
    INVALID_TOKEN: '4005', //无效token
    TOKEN_EXPIRED: '4006', //无效token refresh token
    NEED_LOGIN: '40101' //token过期，需要重新登
};
export { ERROR_CODE };
